import { User } from '../Users/types';

export type CourseEnrolment = {
  name: string;
  path: string;
  promoImage: string;
};

export type InstitutionEnrolment = {
  enrolments: readonly { coursePath: string }[];
  id: string;
  isAdmin: boolean;
  lastActive: string | null;
  user: Pick<User, 'id' | 'fullName' | 'profileName' | 'standardAvatar'> & {
    institutionMembershipId: null | string;
  };
  userGroups: readonly string[];
  staff?: boolean;
};

export enum AsyncState {
  INITIAL = 'INITIAL',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export type PendingInvitation = {
  createdOn: string;
  email: string;
  fullName: string;
  id: string;
};

export type InstitutionAdminSettingsState = {
  paginatedInstitutionEnrolments: {
    asyncState: AsyncState;
    enrolments: readonly InstitutionEnrolment[];
    hasNextPage: boolean;
    hasPrevPage: boolean;
    total: number;
    totalPages: number;
  };
  paginatedPendingInvitations: {
    asyncState: AsyncState;
    hasNextPage: boolean;
    invitedUsers: readonly PendingInvitation[];
    total: number;
  };
};
